export default __webpack_public_path__ + "dcf59e174b9fa6f5d9def8655e457fcb.png";